 <!--企业询价单转为内部询价单-->
 <template>
  <div class="dialog-content">
    <div style="padding-bottom:15px;">
      <div style="display:inline-block;width:200px;">
        期限时间：
        <span>{{objects.NeedTime}}</span>
      </div>
      <div style="display:inline-block;">
        备注：
        <span>{{objects.Remark}}</span>
      </div>
    </div>
    <el-table border="" :fit="true" :data="objectsList" ref="objectsTable">
      <el-table-column type="selection" width="55" prop="Selected" v-if="action=='1'"></el-table-column>
      <el-table-column show-overflow-tooltip prop="GoodsId" label="汽配编码" min-width="160px">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.CodeSel"
            value-key="NewGuid"
            filterable
            remote
            :remote-method="(val)=>getAutoPartsListByCode(val,scope.row.AutoSerieId)"
            :loading="selectloading"
            @change="autoPartsByCodeChange($event,scope.row)"
            clearable
            placeholder="请输入编码"
            default-first-option
            :disabled="action=='3'"
          >
            <template>
              <div class="optionHeader">
                <span style="margin-left:0;">编号</span>
                <span>类型</span>
                <span>名称</span>
                <span>车型</span>
                <span>历史最高价</span>
              </div>
            </template>
            <el-option
              v-for="item in autoPartsListByCode"
              :key="item.NewGuid"
              :label="item.GoodsCode"
              :value="item"
            >
              <span style="margin-left:0px;">{{ item.GoodsCode }}</span>
              <span>{{ item.Type==2?"手动输入":item.Type==1?"历史商品":"基础配件" }}</span>
              <span>{{ item.GoodsName }}</span>
              <span>{{ item.AutoSerieName }}</span>
              <span>{{ item.HistoryMaxPrice }}</span>
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="GoodsName" label="汽配名称" min-width="150px">
        <template slot="header" slot-scope="scope">
          <span class="color-red">*</span>汽配名称
        </template>
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.NameSel"
            value-key="NewGuid"
            filterable
            remote
            :remote-method="(val)=>getAutoPartsListByName(val,scope.row.AutoSerieId)"
            :loading="selectloading"
            @change="autoPartsByNameChange($event,scope.row)"
            clearable
            placeholder="请输入名称"
            default-first-option
            :disabled="action=='3'"
          >
            <template>
              <div class="optionHeader">
                <span style="margin-left:0;">编号</span>
                <span>类型</span>
                <span>名称</span>
                <span>车型</span>
                <span>历史最高价</span>
              </div>
            </template>
            <el-option
              v-for="item in autoPartsListByName"
              :key="item.NewGuid"
              :label="item.GoodsName"
              :value="item"
            >
              <span style="margin-left:0px;">{{ item.GoodsCode }}</span>
              <span>{{ item.Type==2?"手动输入":item.Type==1?"历史商品":"基础配件" }}</span>
              <span>{{ item.GoodsName }}</span>
              <span>{{ item.AutoSerieName }}</span>
              <span>{{ item.HistoryMaxPrice }}</span>
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="车系" min-width="150px">
        <template slot="header" slot-scope="scope">
          <span class="color-red">*</span>车系
        </template>
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.AutoSerieSel"
            value-key="Id"
            filterable
            remote
            :remote-method="getAutoSeriesList"
            @change="AutoSeriesChange($event,scope.row)"
            default-first-option
            clearable
            placeholder="请输入车系名称"
            :disabled="action=='3'"
          >
            <el-option
              v-for="item in autoSeriesList"
              :key="item.Id"
              :label="item.Name"
              :value="item"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="数量" prop="Count"></el-table-column>
      <el-table-column show-overflow-tooltip prop="BrandId" label="品牌" min-width="150px">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.BrandSel"
            value-key="Id"
            filterable
            remote
            :remote-method="getBrandsList"
            :loading="selectloading"
            @change="brandChange($event,scope.row)"
            default-first-option
            clearable
            placeholder="请输入品牌名称"
            :disabled="action=='3'"
          >
            <el-option v-for="item in brandsList" :key="item.Id" :label="item.Name" :value="item"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="单位" min-width="150px">
        <template slot="header" slot-scope="scope">
          <span class="color-red">*</span>单位
        </template>
        <template slot-scope="scope">
          <el-select
            v-model.trim="scope.row.Unit"
            placeholder="请选择单位"
            filterable
            allow-create
            default-first-option
            clearable
            :disabled="action=='3'"
          >
            <el-option v-for="item in Unit" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="价格" min-width="165px">
        <template slot-scope="scope">
          <el-input-number
            size="medium"
            v-model.trim="scope.row.Price"
            :precision="2"
            :step="1.0"
            :min="0"
            @change="handlePriceChange(scope.row)"
            :disabled="action=='3'"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="合计" prop="Total" min-width="90px"></el-table-column>
    </el-table>
    <div style="text-align:right;margin-top:20px;">
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog('cancel')">取 消</el-button>
        <el-button type="primary" @click="submitForm('1')" v-if="action=='1'">转内部询价</el-button>
        <el-button type="primary" @click="submitForm('0')" v-if="action=='2'">保存</el-button>
        <el-button type="success" @click="submitForm('2')" v-if="action=='2'">保存并报价</el-button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "transfromToIIqBill",
  props: {
    objects: { type: Object, default: () => {} },
    action: String //弹窗对应的操作：1转内部询价单，2报价，3查看
  },
  data() {
    return {
      Unit: ["件", "个", "片", "只", "台", "升", "毫升"],
      objectsList: [],
      selectloading: false,
      brandsList: [],
      autoPartsListByName: [],
      autoPartsListByCode: [],
      autoSeriesList: []
    };
  },
  mounted() {
    this.GetEntpInquiryBillGoodsList();
  },
  watch: {},
  methods: {
    //获取企业询价单配件关联列表
    GetEntpInquiryBillGoodsList() {
      this.axios
        .get("/Inquiry/GetEntpInquiryBillGoodsList", {
          params: {
            bid: this.objects.InquiryBillId
          }
        })
        .then(response => {
          //   this.objectsList = response.data.data;
          let datalist = response.data.data;
          this.objectsList = datalist.map(item => {
            this.$set(item, "ObjIdFrom", "unknown"); //对象id是从哪里来的，是选中编码对象得到（Code），还是选中名称对象得到（Name），两者都不是为unknow
            this.$set(item, "Selected", false);
            this.$set(item, "CodeSel", item.GoodsCode);
            this.$set(item, "NameSel", item.GoodsName);
            this.$set(item, "BrandSel", item.BrandName);
            this.$set(item, "AutoSerieSel", item.AutoSerieName);
            this.$set(item, "Total", item.Count * item.Price);
            return item;
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取汽配件列表，其实这里是获取报价记录历史与基本配件的数据
    getAutoPartsListByName(searchKey, autoSeriesId) {
      if (!searchKey) {
        return;
      }
      this.selectloading = true;
      // eslint-disable-next-line no-unused-vars
      let asid = autoSeriesId; //这里不限制车系
      this.axios
        .get("/ERPGood/GetHistoryGoodsAndAutoPartsList", {
          params: { autoSeriesId: "", name: searchKey },
          data: {}
        })
        .then(response => {
          let data = response.data.data;
          if (!data) {
            data = [];
          }
          //添加输入值到第一条
          data.unshift({
            Type: 2,
            GoodsId: "",
            GoodsName: searchKey,
            EnName: "",
            GoodsCode: "",
            HistoryMaxPrice: "",
            AutoSerieName: ""
          });
          this.autoPartsListByName = data;
          this.selectloading = false;
        });
    },
    getAutoPartsListByCode(searchKey, autoSeriesId) {
      if (!searchKey) {
        return;
      }
      this.selectloading = true;
     // eslint-disable-next-line no-unused-vars
      let asid = autoSeriesId; //这里不限制车系
      this.axios
        .get("/ERPGood/GetHistoryGoodsAndAutoPartsList", {
          params: { autoSeriesId: "", code: searchKey },
          data: {}
        })
        .then(response => {
          let data = response.data.data;
          if (!data) {
            data = [];
          }
          //添加输入值到第一条
          data.unshift({
            Type: 2,
            GoodsId: "",
            GoodsName: "",
            EnName: "",
            GoodsCode: searchKey,
            HistoryMaxPrice: "",
            AutoSerieName: ""
          });
          this.autoPartsListByCode = data;
          this.selectloading = false;
        });
    },
    autoPartsByCodeChange(sel, row) {
      // 1编码（选）  名称（补全）  id为编码id
      // 2编码（填）  名称（选）    id为名称id
      // 3编码（补全）名称（选）    id为名称id
      // 4编码（为空）名称（填）    id为空
      // 5编码（选）  名称（改）    id编码id

      //汽配编码，obj:选中的编码对象
      //1.填 名称、id不变
      //2.选 名称=obj名称，id=objid
      //3.清 编码='',名称不变，id=''

      //清
      if (sel == null) {
        row.GoodsId = "";
        row.GoodsCode = "";
        row.GoodsIdType = 2;
        row.ObjIdFrom = "unknown";
      } else {
        //填
        if (sel.Type == 2) {
          row.GoodsCode = sel.GoodsCode;
          row.GoodsIdType = sel.Type;
        } else {
          //选
          row.GoodsId = sel.GoodsId;
          row.GoodsName = sel.GoodsName;
          row.NameSel = sel.GoodsName;
          row.GoodsCode = sel.GoodsCode;
          row.GoodsIdType = sel.Type;
          row.ObjIdFrom = "Code";
        }
      }
    },
    autoPartsByNameChange(sel, row) {
      //汽配名称，obj:选中的名称对象
      //1.填 编码不变，if 编码值是由选中的编码对象得到，编码、id不变  else id=''
      //2.选 if 编码值是由选中的编码对象得到，编码、id不变  else if 编码!='' 编码不变，id=objid  else 编码=obj编码，id=objid
      //3.清 名称='',if 编码值是由选中的编码对象得到，id不变 else id=''

      //清
      if (sel == null) {
        row.GoodsName = "";
        row.GoodsIdType = 2;
        if (row.ObjIdFrom != "Code") {
          row.GoodsId = "";
          row.ObjIdFrom = "unknown";
        }
      } else if (sel.Type == 2) {
        //填
        row.GoodsName = sel.GoodsName;
        row.GoodsIdType = sel.Type;
        if (row.ObjIdFrom != "Code") {
          row.GoodsId = "";
          row.ObjIdFrom = "unknown";
        }
      } else {
        //选
        row.GoodsName = sel.GoodsName;
        row.GoodsIdType = sel.Type;

        if (row.ObjIdFrom == "Code") {
          return true;
        } else if (row.GoodsCode) {
          row.GoodsId = sel.GoodsId;
          row.ObjIdFrom = "Name";
        } else {
          row.GoodsId = sel.GoodsId;
          row.GoodsCode = sel.GoodsCode;
          row.CodeSel = sel.GoodsCode;
          row.ObjIdFrom = "Name";
        }
      }
    },
    //获取品牌列表
    getBrandsList(key) {
      if (!key) {
        return;
      }
      this.selectloading = true;
      this.axios
        .get("/ERPGood/GetMallBrands", {
          params: { name: key },
          data: {}
        })
        .then(response => {
          let data = response.data.data;
          if (!data) {
            data = [];
          }
          if (!data.find(x => x.Name == key)) {
            data.unshift({ Id: "", Name: key });
          }

          this.brandsList = data;
          this.selectloading = false;
        });
    },
    brandChange(sel, row) {
      if (sel) {
        row.BrandId = sel.Id;
        row.BrandName = sel.Name;
      } else {
        row.BrandId = "";
        row.BrandName = "";
      }
    },
    //获取车系列表
    getAutoSeriesList(key) {
      if (!key) {
        return;
      }
      this.axios
        .get("/Common/GetAutoSeriesListByName", {
          params: { SeriesName: key },
          data: {}
        })
        .then(response => {
          let data = response.data.data;
          if (!data) {
            data = [];
          }
          if (!data.find(x => x.Name == key)) {
            data.unshift({ Id: "", Name: key });
          }

          this.autoSeriesList = data;
        });
    },
    AutoSeriesChange(sel, row) {
      if (sel) {
        row.AutoSerieId = sel.Id;
        row.AutoSerieName = sel.Name;
      } else {
        row.AutoSerieId = "";
        row.AutoSerieName = "";
      }
    },
    handlePriceChange(row) {
      row.Total = row.Count * row.Price;
    },
    //action:0保存，1转为内部询价，2报价给客户
    submitForm(action) {
      let objectsList = this.objectsList;
      for (let i = 0; i < objectsList.length; i++) {
        if (
          !objectsList[i].GoodsName ||
          !objectsList[i].Unit ||
          !objectsList[i].AutoSerieName
        ) {
          this.$util.warningMsg("请输入或选中相应的汽配名称、车系、单位");
          return;
        }

        if (action == "2") {
          if (objectsList[i].Price <= 0) {
            this.$util.warningMsg("配件价格必须大于零");
            return;
          } else if (!objectsList[i].GoodsId) {
            this.$util.warningMsg("报价配件不存在数据库中，请转内部询价或选取已存在配件");
            return;
          }
        }
      }
      let _selectData = [];
      if (action == "1") {
        _selectData = this.$refs.objectsTable.selection;
        if (_selectData.length == 0) {
          this.$util.warningMsg("请选中需要询价的配件");
          return;
        }
      }
      let _formData = {
        bid: this.objects.InquiryBillId,
        action: action,
        objectList: objectsList,
        selectedObjectList: _selectData
      };

      this.axios
        .post("/Inquiry/SaveEntpInquiryBill", _formData)
        .then(res => {
          if (res.data.errcode == 0) {
            this.$util.successMsg("保存成功");
            this.closeDialog("save");
          } else {
            this.$message.error(res.data.errmsg);
          }
        })
        .catch(() => {
          this.$message.error("保存失败！");
        });
    },
    closeDialog(action) {
      this.objectsList = [];
      this.$emit("controlIBDialogVisible", { visible: false, action: action });
    }
  }
};
</script>

<style lang="less" scoped>
.optionHeader {
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
  color: #303133;
  font-weight: bold;
}
.optionHeader span {
  float: left;
  margin-left: 20px;
  //   min-width: 150px;
  width: 200px;
  height: 34px;
  line-height: 34px;
}
.el-select-dropdown__list li > span {
  float: left;
  margin-left: 20px;
  //   min-width: 150px;
  width: 200px;
  height: 34px;
  line-height: 34px;
}
</style>